export default "__VITE_ASSET__D_CIt7rO__"